import { observer } from "mobx-react-lite";
import { SectionBackground } from "./SectionBackground";
import { SelectCountryDropDown } from "./SelectCountryDropdown";
import { useCreateLeagueMatchStore } from "../../../store/StoreContext";

export const SelectCountries = observer(() => {
  const createLeagueMatchStore = useCreateLeagueMatchStore();

  // Filtered lists
  const filteredForFirst = createLeagueMatchStore.countries.filter(
    (country) => country.id !== createLeagueMatchStore.secondCountry?.id
  );

  const filteredForSecond = createLeagueMatchStore.countries.filter(
    (country) => country.id !== createLeagueMatchStore.firstCountry?.id
  );

  return (
    <SectionBackground
      title={"Select the countries that will play in this league match"}>
      <div style={{ height: 20 }} />

      <div style={{ display: "flex", justifyContent: "center" }}>
        <SelectCountryDropDown
          placeholder="Select the first country"
          value={createLeagueMatchStore.firstCountry}
          onChange={createLeagueMatchStore.setFirstCountry}
          options={filteredForFirst}
        />
      </div>

      <div style={{ height: 15 }} />

      <div style={{ display: "flex", justifyContent: "center" }}>
        <SelectCountryDropDown
          placeholder="Select the second country"
          value={createLeagueMatchStore.secondCountry}
          onChange={createLeagueMatchStore.setSecondCountry}
          options={filteredForSecond}
        />
      </div>
    </SectionBackground>
  );
});
